import { Text } from "@mantine/core";
import { ReactElement } from "react";
import { DEFAULT_WHITE_COLOR } from "../../../_graphic_design";

interface Props {
  message: string;
}

export default function Message({ message }: Props): ReactElement {
  return (
    <Text
      className="text-2xl text-center font-bold"
      sx={{
        color: DEFAULT_WHITE_COLOR,
      }}
      dangerouslySetInnerHTML={{ __html: message }}
      tt="uppercase"
    />
  );
}
